import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    setLoading(true);
    
    try {
     let response = await login(email, password);
     console.log(response);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      const message =
        err?.response?.data?.message || 'Invalid email or password. Please try again.';
      setError(message);
      console.error('Login error:', message, err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex align-items-center justify-content-center min-h-screen surface-ground">
      <style>{`
        .login-field {
          width: 100%;
        }
        .login-field.p-inputtext,
        .login-field .p-inputtext,
        .login-field.p-password,
        .login-field .p-icon-field {
          width: 100% !important;
          box-sizing: border-box !important;
        }
      `}</style>
      <Card title="Sign In" className="w-full mx-3" style={{ maxWidth: '400px' }}>
        <form onSubmit={handleSubmit} className="flex flex-column gap-3">
          {error && <Message severity="error" text={error} />}

          <div className="flex flex-column gap-2">
            <label htmlFor="email">Email</label>
            <InputText
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoFocus
              className="login-field"
            />
          </div>

          <div className="flex flex-column gap-2">
            <label htmlFor="password">Password</label>
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              feedback={false}
              toggleMask
              placeholder="Enter your password"
              className="login-field"
              inputClassName="login-field"
            />
          </div>

          <Button
            type="submit"
            label="Log In"
            icon="pi pi-sign-in"
            loading={loading}
            className="mt-2"
          />
        </form>
        <a href="/register" className="mt-3 block text-center text-blue-600 hover:underline">
          Don't have an account? Register here.
        </a>
      
      </Card>
    </div>
  );
};

export default Login;